import { isNullOrEmptyArray } from '@/helpers/array-helpers'
import DisputeTimesheetDetailsCandidate from '../disputeTimesheetDetailsCandidate'
import DisputeTimesheetDetailsClient from '../disputeTimesheetDetailsClient'
import CandidateTimeEntries from './candidateTimeEntires'
import DisputeContactDetails from './disputeContactDetails'
import DisputeLocationDetails from './disputeLocationDetails'
import DisputeClientDetails from './disputeClientDetails'

export default class DisputeDetailsResolutionView {
  constructor(data) {
    /** @type {boolean} */
    this.shouldShowRestBreaksQuestion = data.shouldShowRestBreaksQuestion
    /** @type {DisputeContactDetails} */
    this.candidate = new DisputeContactDetails(data.candidate)
    /** @type {Array<DisputeContactDetails>} */
    this.bookingContacts = isNullOrEmptyArray(data.bookingContacts)
      ? []
      : data.bookingContacts.map(
          (contact) => new DisputeContactDetails(contact)
        )
    /** @type {DisputeLocationDetails} */
    this.location = new DisputeLocationDetails(data.location)
    /** @type {DisputeClientDetails} */
    this.client = new DisputeClientDetails(data.client)
    /** @type {string} */
    this.unitType = data.unitType
    /** @type {string} */
    this.payOption = data.payOption
    /** @type {number} */
    this.clientRate = data.clientRate
    /** @type {number} */
    this.candidateRate = data.candidateRate
    /** @type {number} */
    this.candidateQty = data.candidateQty
    /** @type {number} */
    this.clientQty = data.clientQty
    /** @type {number} */
    this.breakMinutes = data.breakMinutes
    /** @type {boolean} */
    this.isCustomClientRate = data.isCustomClientRate
    /** @type {boolean} */
    this.isCustomCandidateRate = data.isCustomCandidateRate
    /** @type {number} */
    this.lunchBreakMinutes = data.lunchBreakMinutes
    /** @type {number} */
    this.classification = data.classification
    /** @type {number} */
    this.hoursBilledClient = data.hoursBilledClient
    /** @type {number} */
    this.hoursPaidCandidate = data.hoursPaidCandidate
    /** @type {number} */
    this.bookingId = data.bookingId
    /** @type {string} */
    this.startDate = data.startDate
    /** @type {string} */
    this.endDate = data.endDate
    /** @type {string} */
    this.startTime = data.startTime
    /** @type {string} */
    this.endTime = data.endTime
    /** @type {DisputeTimesheetDetailsCandidate|null} */
    this.candidateTimesheet = data.candidateTimesheet
      ? new DisputeTimesheetDetailsCandidate(data.candidateTimesheet)
      : null
    /** @type {DisputeTimesheetDetailsClient} */
    this.clientTimesheet = data.clientTimesheet
      ? new DisputeTimesheetDetailsClient(data.clientTimesheet)
      : null
    /** @type {CandidateTimeEntries|null} */
    this.candidateTimeEntries = data.candidateTimeEntries
      ? new CandidateTimeEntries(data.candidateTimeEntries)
      : null
    /** @type {number} */
    this.bookingStatus = data.bookingStatus
    /** @type {boolean} */
    this.candidateHasSubmitted = data.candidateHasSubmitted
    /** @type {boolean} */
    this.clientHasSubmitted = data.clientHasSubmitted
    /** @type {number} */
    this.deltaMinutes = data.deltaMinutes
  }
}
